<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="row">
        <div class="col-sm-1"></div>
        <div class="col">
            <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-40">
                SESQUICENTENARIO <br>
                <span style="line-height: 100%;" class="fontMS500">
                    DE LA INDEPENDENCIA DEL PERÚ <br>
                </span>
            </p>
        </div>
        
    </div>
    
    <div class="titleImagen">
        <div class="container" >
            <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            <br>
                <span style="line-height: 100%;" class="fontMS500">
                <br>
                </span>
            </p>
        </div>
        
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio36/sesquicentenario">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio36/sesquicentenario">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio36/sesquicentenario">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio36/SESQUI-001.png">
</section>

<div class="fondoBlanco_Intro" >
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS700 text-center  font-24 ">
                    <br>
                    EL 16 DE SETIEMBRE DE 1969 SE CREÓ LA COMISIÓN NACIONAL DEL SESQUICENTENARIO DE LA 
                    INDEPENDENCIA DEL PERÚ (CNSIP), DURANTE EL GOBIERNO DE JUAN VELASCO ALVARADO.
                </p>

                <p class="fontMS300 text-center  font-24 ">
                    <br>
                    ESTA COMISIÓN TUVO COMO OBJETIVO:
                    PREPARAR Y DIRIGIR LA EJECUCIÓN DEL PROGRAMA CON QUE SE CONMEMORARÁ, EN TODO EL PAÍS, EL 
                    150 ANIVERSARIO DE LA EMANCIPACIÓN (ART. 3 DEL DL. 17815). CABE PRECISAR QUE UNO DE LOS 
                    OBJETIVOS ESPECÍFICOS DE DICHA COMISIÓN FUE PUBLICAR UNA COLECCIÓN DOCUMENTAL DE LA 
                    INDEPENDENCIA DEL PERÚ, CONSIDERANDO QUE ERA UN PASO TRASCENDENTAL “YA QUE POR PRIMERA 
                    VEZ LAS FUENTES DOCUMENTALES, DE DIFÍCIL ACCESO Y EN LA MAYORÍA DE LOS CASOS FUERA DEL 
                    ALCANCE DE LOS ESTUDIOSOS, ESTARÁN AL ALCANCE DE TODOS LOS ESTUDIOSOS Y EN TODA LA 
                    REPÚBLICA” (MENDOZA, 1970).
                    <br>
                </p>
            </div>
        </div>
    </div>

    <div class="row">
        <img class="img_portada" src="/assets/images/micrositio/micrositio36/SESQUI-002.png">
        <div class="row" style="background-color: #4255d2; ">
            <div class="col-sm-1"></div>
            <div class="col-sm-10">
                <p class="fontMS100 text-center text-white font-20" >
                    <br>
                    Algunos de los miembros de la Comisión Nacional del Sesquicentenario de la Independencia del Perú.<br>
                    <span class="fontMS100Italic">
                        (Estuardo Núñez Hague, Ella Dúnbar Temple Seminario, José Agustín de la Puente y Alberto Tauro del Pino)
                    <br><br>
                    </span>
                </p>
            </div>
            <div class="col-sm-1"></div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
            <p class="fontMS300 text-center font-18" >
                <br><br><br>
                EN ESE SENTIDO, SIENDO ACORDE A SUS FINES INSTITUCIONALES, LA BIBLIOTECA NACIONAL DEL PERÚ CREE CONVENIENTE MAGNIFICAR AQUEL
                OBJETIVO, DIGITALIZANDO DICHA COLECCIÓN Y ESTA VEZ PONIÉNDOLA DE FORMA IRRESTRICTA A DISPOSICIÓN DE TODOS LOS PERUANOS.
                <br><br><br>
            </p>
        </div>
        <div class="col-sm-1"></div>
    </div>

</div>

<div class="fondoNegro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%; margin-top: 1%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            COLECCIÓN DOCUMENTAL<br>
                            DE LA INDEPENDENCIA <br>
                            DEL PERÚ <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                </div>

                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify text-white font-24">
                            <br><br>
                            "LOS IDEÓLOGOS" ES EL PRIMER TOMO DE LA COLECCIÓN DOCUMENTAL DE LA INDEPENDENCIA DEL PERÚ. ESTOS TOMOS 
                            SON SOLO UNA MUESTRA DE TODA LA COLECCIÓN DOCUMENTAL DE LA INDEPENDENCIA DEL PERÚ QUE TENEMOS EN LA 
                            BIBLIOTECA NACIONAL.<br>
                            "LA REBELIÓN DE TÚPAC AMARU" (TOMO II) MUESTRA UN CONTEXTO GENERAL DE LA REBELIÓN LIDERADA POR DICHO 
                            CACIQUE. LOS DOCUMENTOS INSERTOS FUERON RECOPILADOS Y PROLOGADOS POR CARLOS DANIEL VALCÁRCEL Y 
                            GUILLERMO DURAND FLOREZ. "LA EXPEDICIÓN LIBERTADORA" (TOMO VIII; VOLUMEN 1) ES PARTE DE LA COLECCIÓN 
                            DOCUMENTAL DE LA INDEPENDENCIA DEL PERÚ QUE SE ENCUENTRA EN LA BNP. 
                            <br><br>
                        </p>
                    </div>
                </div>

                <div class="row mt-5 " style="padding: 0; margin: 0;">
                    <div class="col-sm-6 " style="padding: 0%; margin: 0%;">
                        <p class="text-center" style="margin: 0;">
                            <a href="https://bibliotecadigital.bnp.gob.pe/collections/f1b5f6ff-f827-4e1f-a2d9-7113d10dec5d?origin=internal" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio36\SESQUI-003.png">
                            </a>
                            
                        </p>
                    </div>
                    <div class="col-sm-6 " style="padding: 0% ; margin: 0%;">
                        <p class="text-center" style="margin: 0;">
                            <a href="https://bibliotecadigital.bnp.gob.pe/collections/f1b5f6ff-f827-4e1f-a2d9-7113d10dec5d?origin=internal" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio36\SESQUI-004.png">
                            </a>
                            
                        </p>
                    </div>
                    <div class="col-sm-6 " style="padding: 0%; margin: 0%; ">
                        <p class="text-center" style="margin: 0;">
                            <a href="https://bibliotecadigital.bnp.gob.pe/collections/f1b5f6ff-f827-4e1f-a2d9-7113d10dec5d?origin=internal" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio36\SESQUI-005.png">
                            </a>
                            
                        </p>
                    </div>
                    <div class="col-sm-6 " style="padding: 0%; margin: 0%;">
                        <p class="text-center" style="margin: 0;">
                            <a href="https://bibliotecadigital.bnp.gob.pe/collections/f1b5f6ff-f827-4e1f-a2d9-7113d10dec5d?origin=internal" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio36\SESQUI-006.png">
                            </a>
                            
                        </p>
                    </div>
                    <div class="row mt-5">
                        <p class="text-center text-white" >
                            Colección Documental de la Independencia del Perú (CDIP) completa disponible en: <br>
                            <a href="https://bibliotecadigital.bnp.gob.pe/collections/f1b5f6ff-f827-4e1f-a2d9-7113d10dec5d?origin=internal" target="_blank" style="color: #ffffff;">Biblioteca Digital</a> <br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzul">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio36/SESQUI-LINEA-001.png" width="100%">
                <div class="row marg">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-11">
                        <p class="fontMS500 text-center font-18 text-white">
                            <br>
                            «YA NO SERÁ PRIVILEGIO DE ALGUNOS CONOCER LAS FUENTES DE LA HISTORIA DEL PERÚ, SERÁ UNA NUEVA 
                                POSIBILIDAD PARA TODOS». 
                            <br>
                        </p>
                        <div class="text-right">
                            <p class="fontMS300 text-center font-16 text-white">
                                <br>
                                (EXTRACTO DEL BOLETÍN INFORMATIVO Nº 1 DE LA CNSIP (1970). DICHO ÓRGANO DE DIFUSIÓN FUE CREADO PARA INFORMAR SOBRE LOS 
                                AVANCES CONMEMORATIVOS DESARROLLADOS POR LA MENCIONADA COMISIÓN Y TUVO 19 ENTREGAS, APARECIDAS ENTRE ENERO DE 1970 Y 
                                DICIEMBRE DE 1974).
                                <br>
                            </p>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio36/SESQUI-LINEA-001.png" class="reflejo"
                width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%; margin-top: 1%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            LA COMISIÓN<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                </div>

                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-center font-24">
                            <br><br>
                            LA PRESIDENCIA DE LA COMISIÓN NACIONAL DEL SESQUICENTENARIO DE LA INDEPENDENCIA DEL PERÚ FUE 
                            ASUMIDA POR EL GENERAL DE DIVISIÓN EP JUAN MENDOZA RODRÍGUEZ, EN REPRESENTACIÓN DEL ESTADO 
                            PERUANO, ENTRE 1969 Y 1974. ASI MISMO, LA COMISIÓN FUE INTEGRADA POR REPRESENTANTES DE 
                            INSTITUCIONES DEL ESTADO, COMUNIDAD ACADÉMICA Y LA SOCIEDAD CIVIL, TALES COMO:
                            <br><br>
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-5">
                        <p class="fontMS100 text-center font-20">
                            <br>
                            <span class="fontMS700">DR. ESTUARDO NÚÑEZ</span><br>
                            BIBLIOTECA NACIONAL DEL PERÚ
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            
                            <span class="fontMS700">DRA. ELLA DUNBAR TEMPLE</span><br>
                            SOCIEDAD PERUANA DE HISTORIA
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            
                            <span class="fontMS700">R.P. ARMANDO NIETO VÉLEZ</span><br>
                            ASAMBLEA EPISCOPAL DEL PERÚ
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">DR. JOSÉ AGUSTÍN DE LA PUENTE CANDAMO</span><br>
                            INSTITUTO RIVA-AGÜERO
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">GRAL. DE BRIGADA JUAN ABAD BERMÚDEZ</span><br>
                            FUERZA ARMADA Y FUERZAS AUXILIARES
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">JOSÉ FERNÁNDEZ PINILLOS</span><br>
                            CONCEJO PROVINCIAL DE LIMA
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">DR. ALBERTO TAURO DEL PINO</span><br>
                            CONSEJO NACIONAL DE LA UNIVERSIDAD PERUANA
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">DR. AURELIO MIRÓ QUESADA SOSA</span><br>
                            ACADEMIA NACIONAL DE HISTORIA
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">GRAL. DE BRIGADA FELIPE DE LA BARRA UGARTE</span><br>
                            CENTRO DE ESTUDIOS MILITARES DEL PERÚ
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">DR. GUSTAVO PONS MUZZO</span><br>
                            CINSTITUTO SANMARTINIANO DEL PERÚ
                            <br><br>
                        </p>
                    </div>

                    <div class="col-sm-2"></div>

                    <div class="col-sm-5">
                        <p class="fontMS100 text-center font-20">
                            <br>
                            <span class="fontMS700">DR. AUGUSTO TAMAYO VARGAS</span><br>
                            SOCIEDAD BOLIVARIANA DEL PERÚ
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            
                            <span class="fontMS700">DCAPITÁN DE NAVÍO JULIO J. ELÍAS</span><br>
                            SOCIEDAD DE FUNDADORES DE LA INDEPENDENCIA, VENCEDORES DEL 2 DE MAYO DE 
                            1866 Y DEFENSORES CALIFICADOS DE LA PATRIA
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">DR. FÉLIX DENEGRI LUNA</span><br>
                            INSTITUTO LIBERTADOR RAMÓN CASTILLA
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">DR. GUILLERMO DURAND FLOREZ</span><br>
                            ARCHIVO NACIONAL
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">GRAL. MANUEL A. REMOND CÁRDENAS</span><br>
                            POR LA SOCIEDAD FUNDADORES DE LA 
                            INDEPENDENCIA, VENCEDORES EL 2 DE MAYO DE 
                            1866 Y DEFENSORES CALIFICADOS DE LA PATRIA
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">DOCTOR TOMÁS CATANZARO</span><br>
                            POR EL INSTITUTO LIBERTADOR RAMÓN CASTILLA
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">GRAL. DE BRIGADA EP LUIS VIGNES RODRÍGUEZ</span><br>
                            REPRESENTANTE DE LA FUERZA ARMADA Y 
                            FUERZAS AUXILIARES
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20">
                            <span class="fontMS700">DR. GUILLERMO LOHMANN VILLENA</span><br>
                            POR EL MINISTERIO DE RELACIONES EXTERIORES
                            <br><br>
                        </p>
                    </div>
                </div>

                <div class="row mt-5 position-relative">
                    <img src="\assets\images\micrositio\micrositio36\SESQUI-CUADRO-000.png" class="img-fluid">
                    <div class="col-sm-5 position-absolute" style="top: 23%; left: 3%;">
                        <img src="\assets\images\micrositio\micrositio36\SESQUI-007.png"class="position-relative img-fluid2" >
                        <p class="fontMS100Italic text-center text-white font12 position-absolute centrar">
                            Ella Dúnbar Temple Seminario (1918 - 1998) y Guillermo<br>
                            Lohmann Villena (1915 - 2005)
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-2 position-absolute" ></div>
                    <div class="col-sm-5 position-absolute centrar2">
                        <p class="fontMS500 text-center text-white font14 mt-5">
                            LA CNSIP TUVO CINCO COMITÉS Y CADA UNO<br>
                            FUE PRESIDIDO POR:
                            <br>
                        </p>
                        <p class="fontMS100 text-left  text-white font14">
                            <span class="fontMS500">PUBLICACIONES-</span>
                            DR. ALBERTO TAURO DEL PINO
                            <br>
                        </p>
                        <p class="fontMS100 text-left  text-white font14">
                            <span class="fontMS500">DOCUMENTOS-</span>
                            DRA. ELLA DUNBAR TEMPLE Y DR. JOSÉ A. DE LA PUENTE CANDAMO
                            <br>
                        </p>
                        <p class="fontMS100 text-left  text-white font14">
                            <span class="fontMS500">COMITÉ DEL V CONGRESO DE HISTORIA DE AMÉRICA-</span>
                            DR. AURELIO MIRÓ QUESADA SOSA
                            <br>
                        </p>
                        <p class="fontMS100 text-left  text-white font14">
                            <span class="fontMS500">COMITÉ DE ACTUACIONES PÚBLICAS Y MONUMENTOS NACIONALES-</span>
                            GENERAL JUAN ABAD BERMÚDEZ, 
                            GENERAL ROBERTO ZAPATA VÉLEZ Y CORONEL LUIS 
                            VIGNES RODRÍGUEZ
                            <br>
                        </p>
                        <p class="fontMS100 text-left  text-white font14">
                            <span class="fontMS500">COMITÉ ECONÓMICO-</span>
                            DR. FÉLIX DENEGRI LUNA
                            <br>
                        </p>
                    </div>

                </div>

                <div class="row mt-5">
                    <p class="fontMS100 text-center font-20">
                        <br><br>
                        LOS MENCIONADOS INTEGRABAN EL COMITÉ EJECUTIVO ADEMÁS DEL PRESIDENTE DE LA COMISIÓN 
                        GENERAL DE DIVISIÓN JUAN MENDOZA RODRÍGUEZ, EL VICEPRESIDENTE GENERAL DE BRIGADA FELIPE DE 
                        LA BARRA UGARTE Y EL SECRETARIO GENERAL, DR. GUSTAVO PONS MUZZO
                        <br><br>
                    </p>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoNegro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%; margin-top: 1%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            EL TERREMOTO DE ÁNCASH<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                </div>

                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify text-white font-24">
                            <br><br>
                            EL TERREMOTO DE ANCASH, OCURRIDO EL 31 DE MAYO DE 1970, AFECTÓ LAS ACTIVIDADES CONMEMORATIVAS POR EL 150 
                            ANIVERSARIO DE LA INDEPENDENCIA DEL PERÚ. EN ESE LUCTUOSO CONTEXTO, LA COMISIÓN NACIONAL DEL 
                            SESQUICENTENARIO PROPUSO AL GOBIERNO REALIZAR LAS ACTIVIDADES PROGRAMADAS DE FORMA AUSTERA Y 
                            PRIORIZANDO LO CONMEMORATIVO SOBRE LO FESTIVO.
                            <br><br>
                        </p>
                    </div>
                </div>

                <div class="row mt-5 " style="padding: 0; margin: 0;">
                    <div class="col-sm-6 " style="padding: 0%; margin: 0%;">
                        <p class="text-center" style="margin: 0;">
                            <a href="https://elcomercio.pe/peru/ancash/imagenes-ineditas-terremoto-1970-callejon-huaylas-noticia-524186-noticia/?foto=4" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio36\SESQUI-008.png">
                            </a>
                            
                        </p>
                    </div>
                    <div class="col-sm-6 " style="padding: 0% ; margin: 0%;">
                        <p class="text-center" style="margin: 0;">
                            <a href="https://elcomercio.pe/peru/ancash/imagenes-ineditas-terremoto-1970-callejon-huaylas-noticia-524186-noticia/?foto=4" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio36\SESQUI-009.png">
                            </a>
                            
                        </p>
                    </div>
                    <div class="col-sm-6 " style="padding: 0%; margin: 0%; ">
                        <p class="text-center" style="margin: 0;">
                            <a href="https://elcomercio.pe/peru/ancash/imagenes-ineditas-terremoto-1970-callejon-huaylas-noticia-524186-noticia/?foto=4" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio36\SESQUI-010.png">
                            </a>
                            
                        </p>
                    </div>
                    <div class="col-sm-6 " style="padding: 0%; margin: 0%;">
                        <p class="text-center" style="margin: 0;">
                            <a href="https://elcomercio.pe/peru/ancash/imagenes-ineditas-terremoto-1970-callejon-huaylas-noticia-524186-noticia/?foto=4" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio36\SESQUI-011.png">
                            </a>
                            
                        </p>
                    </div>
                    <div class="row mt-5">
                        <p class="fontMS100Italic text-center text-white" >
                            Fotos después del terremoto de 1970 en el Callejón de Huaylas, Áncash. <br>
                            Fuente: 
                            <a href="https://elcomercio.pe/peru/ancash/imagenes-ineditas-terremoto-1970-callejon-huaylas-noticia-524186-noticia/?foto=4" target="_blank" style="color: #ffffff;">Diario el Comercio</a> <br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%; margin-top: -2%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            ACTIVIDADES PREPARADAS<br>
                            POR LA CNSIP
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                </div>

                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-center font-24">
                            <br><br>
                            LAS ACTIVIDADES PREPARADAS POR LA COMISIÓN NACIONAL DEL SESQUICENTENARIO DE LA 
                            INDEPENDENCIA DEL PERÚ (CNSIP), FUERON DIVERSAS, ENTRE LAS MÁS IMPORTANTES ENCONTRAMOS:
                            <br><br>
                        </p>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-sm-1">
                            <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-N-000.png">
                    </div>
                    <div class="col-sm-11">
                            <p style="line-height: 120%;margin-bottom: 0%; margin-top: 0%;"
                                class="fontMS700 text-left colorPrincipal font-38">
                                CONCURSO SOBRE TEMAS HISTÓRICOS Y LOS ILUSTRES GANADORES<br>
                                    
                            </p>
                    </div>
                </div>

                <div class="row marg">
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify font-20 text-gris">
                            <br> <br> 
                            LA COMISIÓN LANZÓ UNA INTERESANTE 
                            CONVOCATORIA DIRIGIDA A LA 
                            CIUDADANÍA EN GENERAL Y EN LA QUE 
                            DESTACADOS HISTORIADORES, ENSAYISTAS 
                            Y DEMÁS ACADÉMICOS DE LA ÉPOCA 
                            PARTICIPARON. RESALTÓ ENTRE LOS 
                            GANADORES UN JOVENCÍSIMO 
                            ESTUDIANTE DE ESCUELA, HUGO PEREYRA 
                            (EN LA ACTUALIDAD ES UN RECONOCIDO 
                            DIPLOMÁTICO E HISTORIADOR).<br>  
                        </p>
                    </div>
                    <div class="col-sm-6">
                            
                            <img width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-012.png">
                            <p class="fontMS500Italic text-center font-12">
                                Fotografía de Hugo Pereyra Plascencia.<br>  
                            </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-20">
                            LA COMISIÓN LANZÓ UNA INTERESANTE CONVOCATORIA DIRIGIDA A LA CIUDADANÍA EN GENERAL Y EN 
                            LA QUE DESTACADOS HISTORIADORES, ENSAYISTAS Y DEMÁS ACADÉMICOS DE LA ÉPOCA PARTICIPARON. 
                            RESALTÓ ENTRE LOS GANADORES UN JOVENCÍSIMO ESTUDIANTE DE ESCUELA, HUGO PEREYRA (EN LA 
                            ACTUALIDAD ES UN RECONOCIDO DIPLOMÁTICO E HISTORIADOR).<br><br>  
                            EL CONCURSO BUSCABA RECOPILAR LOS MEJORES ENSAYOS, LIBROS, REPORTES, ESCRITOS ALUSIVOS AL 
                            TEMA DE LA EMANCIPACIÓN PERUANA. EN LA ACTUALIDAD, ESTA DOCUMENTACIÓN ES CONSIDERADA 
                            VALIOSA POR REVELAR DETALLES DE LA LUCHA POR LIBERARNOS DEL YUGO ESPAÑOL, Y QUE CONFIRMA 
                            LA PRONTA CELEBRACIÓN DEL BICENTENARIO DE NUESTRA INDEPENDENCIA.<br><br>
                            ENTRE LAS OBRAS O AUTORES PREMIADOS ESTABAN ILUSTRES PERSONAJES QUE HOY TAMBIÉN RELUCEN, 
                            TALES COMO:<br>  <br>  <br>  
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4">
                        <img width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-013.png">
                        <p class="fontMS500Italic text-center font-12">
                            Fotografía de Raúl Palacios Rodríguez.<br>  
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-014.png">
                        <p class="fontMS500Italic text-center font-12">
                            Fotografía de María Luisa Rivara.<br>  
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-015.png">
                        <p class="fontMS500Italic text-center font-12">
                            Fotografía de José Ignacio López Soria<br>
                            (Rector de la UNI)<br>  
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-016.png">
                        <p class="fontMS500Italic text-center font-12">
                            Fotografía de Andrés Townsend Ezcurra.<br>  
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-017.png">
                        <p class="fontMS500Italic text-center font-12">
                            Fotografía de María Cecilia Bákula<br>
                            (Directora del INC).<br>  
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="https://bibliotecadigital.bnp.gob.pe/collections/f1b5f6ff-f827-4e1f-a2d9-7113d10dec5d?origin=internal" target="_blank">
                            <img width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-018.png">
                        </a>
                        
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-20">
                            <br>  <br>  
                            POSTERIORMENTE, LAS OBRAS FUERON IMPRESAS Y PUBLICADAS. EN LA BNP SE PUEDEN ENCONTRAR 
                            LAS PUBLICACIONES EN FÍSICO Y DIGITALIZADAS.<br>  
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoNegro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1">
                            <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-N-001.png">
                    </div>
                    <div class="col-sm-11">
                            <p style="line-height: 120%;margin-bottom: 0%; margin-top: 0%;"
                                class="fontMS700 text-left colorPrincipal font-38">
                                COLECCIÓN DOCUMENTAL DE LA INDEPENDENCIA DEL PERÚ<br>
                                    
                            </p>
                    </div>
                </div>

                <div class="row marg">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-20 text-white">
                            <br> <br> 
                            ES UNA IMPORTANTE COMPILACIÓN DE DOCUMENTOS Y FUENTES PRIMARIAS RECOPILADAS EN VARIOS 
                            PAÍSES Y DEPARTAMENTOS DEL PERÚ SOBRE EL PROCESO DE LA EMANCIPACIÓN PERUANA. ESTOS 
                            TOMOS ORIGINALES SE ENCUENTRAN EN LA BNP, DONDE SON CUSTODIADOS Y A LOS QUE SE PUEDE 
                            ACCEDER EN LAS SALAS DE LECTURA. TAMBIÉN ESTÁN DIGITALIZADOS Y PUBLICADOS EN LA 
                            PLATAFORMA DE LA BIBLIOTECA DIGITAL. LOS DOCUMENTOS AQUÍ PRESENTADOS SON FUENTES 
                            PRIMARIAS INVALUABLES.<br><br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                    <div class="col-sm-8">
                        <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-019.png">
                        <p class="fontMS300Italic text-center text-white font-12">
                            <br>  
                            Estuardo Nuñez, exdirector de la Biblioteca Nacional del Perú, escribió el estudio preliminar e hizo la compilación en 
                            "Relaciones de viajeros". "Relaciones de viajeros" es una compilación de las opiniones de viajeros durante el proceso de 
                            emancipación, reunidas por Estuardo Núñez.<br>  
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                    
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-20 text-white">
                            <br> <br> 
                            ENTRE SUS PRINCIPALES DOCUMENTOS SE PUEDEN ENCONTRAR: REPORTES OFICIALES SOBRE LA 
                            REBELIÓN DEL INDÓMITO TÚPAC AMARU, ESCRITOS Y ENSAYOS POLÍTICOS DE REPUTADOS IDEÓLOGOS 
                            COMO VISCARDO Y GUZMÁN, SÁNCHEZ CARRIÓN, ENTRE OTROS; TODOS FUNDAMENTOS A FAVOR DE 
                            LA INDEPENDENCIA DE AMÉRICA, TAMBIÉN PUEDES ENCONTRAR REPRODUCCIONES DE PERIÓDICOS DE 
                            LA ÉPOCA, REPORTES PERIODÍSTICOS DE DIVERSA ÍNDOLE, INTERESANTES GRABADOS, MAPAS, 
                            CONVENIOS Y MÁS.<br><br><br><br>
                        </p>
                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                                <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-020.png">
                                <p class="fontMS300Italic text-center text-white font-12">
                                    <br>  
                                    Ilustración incluida en el libro “Relaciones de viajeros” que retrata a 
                                    uno de los exploradores de las expediciones oficiales que cumplían 
                                    misiones encomendadas. Los viajeros solían ser comerciantes, mineros 
                                    y científicos, mineros y científicos de diferentes lugares del mundo: 
                                    ingleses, franceses, alemanes y más.<br>  
                                </p>
                        </div>
                        <div class="col-sm-6">
                            <a href="https://bibliotecadigital.bnp.gob.pe/collections/f1b5f6ff-f827-4e1f-a2d9-7113d10dec5d?origin=internal" target="_blank">
                                <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-021.png">
                            </a>
                                <p class="fontMS300Italic text-center text-white font-12">
                                    <br>  
                                    Los ideólogos y la Rebelión de Túpac Amaru son dos importantes compilaciones 
                                    originales que se pueden encontrar en las salas de lectura de la BNP, y en formato 
                                    digital en la plataforma de BNP Digital, en el siguiente enlace:<br>  
                                    <a href="https://bibliotecadigital.bnp.gob.pe/collections/f1b5f6ff-f827-4e1f-a2d9-7113d10dec5d?origin=internal" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital
                                    </a>
                                    <br>  
                                </p>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-4">
                            <a href="http://hdl.handle.net/20.500.14428/79818" target="_blank">
                            <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-022.png">
                        </a>
                            <p class="fontMS300Italic text-center text-white font-12">
                                <br>  
                                Conspiraciones y Rebeliones en el siglo XIX.
                                Colección Documental de la Independencia del 
                                Perú, Tomo III.<br><br>
                                Disponible en: <br>  
                                <a href="http://hdl.handle.net/20.500.14428/79818" target="_blank" style="color: #ffffff;">
                                    Biblioteca Digital
                                </a>
                                <br><br><br>    
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <a href="http://hdl.handle.net/20.500.14428/79806" target="_blank">
                                <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-023.png">
                            </a>
                            <p class="fontMS300Italic text-center text-white font-12">
                                <br>  
                                El Perú en las Cortes de Cádiz.
                                Colección Documental de la Independencia del 
                                Perú, Tomo IV.<br><br>
                                Disponible en:<br>  
                                <a href="http://hdl.handle.net/20.500.14428/79806" target="_blank" style="color: #ffffff;">
                                    Biblioteca Digital
                                </a>
                                <br><br><br>   
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <a href="http://hdl.handle.net/20.500.14428/79883" target="_blank">
                                <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-024.png">
                            </a>
                            <p class="fontMS300Italic text-center text-white font-12">
                                <br>  
                                El Teatro en la Independencia.
                                Colección Documental de la Independencia del 
                                Perú, Tomo XXV.<br>  <br>  
                                Disponible en: <br>  
                                <a href="http://hdl.handle.net/20.500.14428/79883" target="_blank" style="color: #ffffff;">
                                    Biblioteca Digital
                                </a>
                                <br><br><br>   
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <a href="http://hdl.handle.net/20.500.14428/79870" target="_blank">
                                <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-025.png">
                            </a>
                            
                            <p class="fontMS300Italic text-center text-white font-12">
                                <br>  
                                La acción patriótica del Pueblo en la Emancipación 
                                Guerrillas y Montoneras.
                                Colección Documental de la Independencia del 
                                Perú, Tomo V.<br><br>
                                Disponible en: <br>  
                                <a href="http://hdl.handle.net/20.500.14428/79870" target="_blank" style="color: #ffffff;">
                                    Biblioteca Digital
                                </a>
                                <br><br><br>    
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <a href="http://hdl.handle.net/20.500.14428/79785" target="_blank">
                                <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-026.png">
                            </a>
                            
                            <p class="fontMS300Italic text-center text-white font-12">
                                <br>  
                                La Iglesia.<br>
                                Colección Documental de la Independencia del 
                                Perú, Tomo XX.<br><br>
                                Disponible en: <br>  
                                <a href="http://hdl.handle.net/20.500.14428/79785" target="_blank" style="color: #ffffff;">
                                    Biblioteca Digital
                                </a>
                                <br><br><br>    
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <a href="http://hdl.handle.net/20.500.14428/79823" target="_blank">
                                <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-027.png">
                            </a>
                            
                            <p class="fontMS300Italic text-center text-white font-12">
                                <br>  
                                Los Ideólogos.<br>
                                Colección Documental de la Independencia del 
                                Perú, Tomo I.<br><br>
                                Disponible en:<br>  
                                <a href="http://hdl.handle.net/20.500.14428/79823" target="_blank" style="color: #ffffff;">
                                    Biblioteca Digital
                                </a>
                                <br><br><br>    
                            </p>
                        </div>

                        <div class="col-sm-4"></div>
                        <div class="col-sm-4">
                            <a href="http://hdl.handle.net/20.500.14428/79891" target="_blank">
                                <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-028.png">
                            </a>
                            
                            <p class="fontMS300Italic text-center text-white font-12">
                                <br>  
                                Obra de Gobierno y Epistolario de San Martín.
                                Colección Documental de la Independencia del 
                                Perú, Tomo XIII.<br><br>
                                Disponible en:<br>  
                                <a href="http://hdl.handle.net/20.500.14428/79891" target="_blank" style="color: #ffffff;">
                                    Biblioteca Digital
                                </a>
                                <br><br><br>    
                            </p>
                        </div>
                        <div class="col-sm-4"></div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1">
                            <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-N-002.png">
                    </div>
                    <div class="col-sm-11">
                            <p style="line-height: 120%;margin-bottom: 0%; margin-top: 1%;"
                                class="fontMS700 text-left colorPrincipal font-38">
                                INAUGURACIÓN DE MONUMENTOS HISTÓRICOS<br>
                                    
                            </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-24">
                            <br>
                            EN LA HEMEROTECA DE LA BNP (SAN BORJA) , ENCONTRARÁS PERIÓDICOS ORIGINALES DE LA ÉPOCA 
                            REPORTANDO LAS ACTIVIDADES DE LA COMISIÓN, COMO LA INAUGURACIÓN DE LOS MONUMENTOS 
                            CONMEMORATIVOS A LAS CELEBRACIONES DEL SESQUICENTENARIO DE LA INDEPENDENCIA DEL PERÚ.<br>
                            DICHOS MONUMENTOS TAMBIÉN FUERON PARTE DE LA TAREA QUE EL GOBIERNO LE ASIGNÓ A LA COMISIÓN 
                            EN AQUELLA ÉPOCA.
                            <br><br>
                        </p>
                    </div>
                </div>
                
                <div class="row marg">
                    <div class="col-sm-12">
                            <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-029.png">
                            <div class="row">
                                <div class="col-sm-2"></div>
                                <div class="col-sm-8">
                                    <p class="fontMS500Italic text-center font-12">
                                        <br>
                                        Estos periódicos reportaron las notas sobre las inauguraciones de los monumentos. Hoy, bajo la custodia de la BNP, son 
                                        accesibles al público interesado con solo presentar su DNI en la sala de hemeroteca.<br>
                                    </p>
                                </div>
                                <div class="col-sm-2"></div>
                                
                            </div>
                            
                    </div>
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-20">
                            <br><br>
                            EN LA HEMEROTECA DE LA BNP (SAN BORJA) , ENCONTRARÁS PERIÓDICOS ORIGINALES DE LA ÉPOCA 
                            REPORTANDO LAS ACTIVIDADES DE LA COMISIÓN, COMO LA INAUGURACIÓN DE LOS MONUMENTOS 
                            CONMEMORATIVOS A LAS CELEBRACIONES DEL SESQUICENTENARIO DE LA INDEPENDENCIA DEL PERÚ.<br>
                            DICHOS MONUMENTOS TAMBIÉN FUERON PARTE DE LA TAREA QUE EL GOBIERNO LE ASIGNÓ A LA COMISIÓN 
                            EN AQUELLA ÉPOCA.<br>
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS700 text-left font-24 colorPrincipal">
                            <br> <br> 
                            EL GENERAL JUAN MENDOZA HIZO UN INFORME DETALLADO SOBRE LOS MONUMENTOS 
                            ERIGIDOS POR LA COMISIÓN QUE SE DETALLAN A CONTINUACIÓN:<br>  <br>  
                        </p>
                    </div>


                    <div class="row ">
                        <p class="fontMS500Italic text-left font-20 colorPrincipal">
                            <br> <br> 
                            Fecha de Inauguración<br>  <br>  
                        </p>
                        <div class="col-sm-1 img-tiempo">
                            <img 
                            src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-003.png">
                        </div>
                        <div class="col-sm-5">
                            <p class="fontMS100 text-left font-18">
                                <span class="fontMS300Italic colorPrincipal font-20"> 08.09.1970<br> 
                                </span> 
                                    MONUMENTO A SAN MARTÍN Y A LA 
                                    EXPEDICIÓN LIBERTADORA. PARACAS.
                            </p>
                            <p class="fontMS100 text-left font-18">
                                <span class="fontMS300Italic colorPrincipal font-20"> 28.11.1970<br> 
                                </span> 
                                MONUMENTO AL GENERAL FRANCISCO DE 
                                VIDAL. SUPE.<br><br> 
                            </p>
                            <p class="fontMS100 text-left font-18">
                                <span class="fontMS300Italic colorPrincipal font-20"> 06.12.1970<br> 
                                </span> 
                                MONUMENTO AL GENERAL JUAN ANTONIO 
                                ÁLVAREZ DE ARENALES. CERRO DE PASCO.<br><br> <br>
                            </p>
                            <p class="fontMS100 text-left font-18">
                                <span class="fontMS300Italic colorPrincipal font-20"> 27.07.1971<br> 
                                </span> 
                                MONUMENTO A LOS PRÓCERES DE LA 
                                INDEPENDENCIA. LIMA.<br><br><br>
                            </p>
                            <p class="fontMS100 text-left font-18">
                                <span class="fontMS300Italic colorPrincipal font-20"> 20.06.1972<br> 
                                </span> 
                                MONUMENTO A FRANCISCO DE ZELA. TACNA.<br><br>
                            </p>
                            <p class="fontMS100 text-left font-18">
                                <span class="fontMS300Italic colorPrincipal font-20"> 20.06.1972<br> 
                                </span> 
                                MONUMENTO A MARÍA PARADO DE BELLIDO. 
                                SURCO (LIMA).   <br><br>
                            </p>
                            <p class="fontMS100 text-left font-18">
                                <span class="fontMS300Italic colorPrincipal font-20"> 30.06.1974<br> 
                                </span> 
                                MONUMENTO A JUAN PABLO VISCARDO Y 
                                GUZMÁN. AREQUIPA<br><br><br>
                            </p>
                            <p class="fontMS100 text-left font-18">
                                <span class="fontMS300Italic colorPrincipal font-20"> 12.07.1974<br> 
                                </span> 
                                MONUMENTO AL ALMIRANTE MARTÍN JORGE 
                                GUISE. CALLAO.<br><br>
                            </p>
                            <p class="fontMS100 text-left font-18">
                                <span class="fontMS300Italic colorPrincipal font-20"> 25.07.1974<br> 
                                </span> 
                                MONUMENTO AL MARISCAL TORIBIO DE 
                                LUZURIAGA. HUARAZ<br><br><br>
                            </p>
                            <p class="fontMS100 text-left font-18">
                                <span class="fontMS300Italic colorPrincipal font-20"> 06.08.1974<br> 
                                </span> 
                                MONUMENTO AL CORONEL JOSÉ ANDRÉS RÁZURI. 
                                SAN PEDRO DE LLOC (LA LIBERTAD).<br><br><br><br>
                            </p>
                            <p class="fontMS100 text-left font-18">
                                <span class="fontMS300Italic colorPrincipal font-20"> 16.10.1974<br> 
                                </span> 
                                MONUMENTO A GARCILASO DE LA VEGA. LIMA.<br><br><br>
                            </p>
                            <p class="fontMS100 text-left font-18">
                                <span class="fontMS300Italic colorPrincipal font-20"> 09.12.1974<br> 
                                </span> 
                                MONUMENTO A LOS VENCEDORES DE LA BATALLA 
                                DE AYACUCHO. AYACUCHO.<br>
                            </p>
                        </div>
                        <div class="col-sm-2"></div>
                        <div class="col-sm-4">
                            <div class="row marg">
                                <div class="col-sm-12">
                                    <img width="100%"
                                    src="\assets\images\micrositio\micrositio36\SESQUI-030.png">
                                    <p class="fontMS500Italic text-center font-12 colorPrincipal">
                                        <br>
                                        Monumento conmemorativo del 
                                        desembarco de San Martín y la 
                                        expedición libertadora de Paracas<br>  <br>
                                    </p>
                                </div>
                                <div class="col-sm-12">
                                    <img width="100%"
                                    src="\assets\images\micrositio\micrositio36\SESQUI-031.png">
                                    <p class="fontMS500Italic text-center font-12 colorPrincipal">
                                        <br>
                                        Monumento a los 
                                        Precursores y Próceres de 
                                        la Independencia en Lima<br>  <br>
                                    </p>
                                </div>
                                <div class="col-sm-12">
                                    <img width="100%"
                                    src="\assets\images\micrositio\micrositio36\SESQUI-032.png">
                                    <p class="fontMS500Italic text-center font-12 colorPrincipal">
                                        <br>
                                        Monumento a Andrés Rázuri 
                                        en San Pedro de Lloc<br>  <br>
                                    </p>
                                </div>
                                <div class="col-sm-12">
                                    <img width="100%"
                                    src="\assets\images\micrositio\micrositio36\SESQUI-033.png">
                                    <p class="fontMS500Italic text-center font-12 colorPrincipal">
                                        <br>
                                        Monumento a los vencedores de Ayacucho<br>  <br>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-center font-20">
                            <br><br><br>
                            ASIMISMO, SE INAUGURARON PLACAS Y BUSTOS EN HONOR A TODOS AQUELLOS QUE CON SU APORTE, 
                            PENSAMIENTO Y EJERCICIO CONTRIBUYERON CON LA EMANCIPACIÓN PERUANA. ALGUNOS PLASMARON SU 
                            GRATITUD Y ADMIRACIÓN POR QUIENES LUCHARON POR NUESTRA LIBERACIÓN EN OBRAS ARTÍSTICAS 
                            COMO: ÓLEOS, FRISOS, MURALES Y MAQUETAS.<br><br>
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <img width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-034.png">
                        <p class="fontMS500Italic text-center font-12 colorPrincipal">
                            <br>
                            Esta es la maqueta ganadora del concurso en honor al 
                            desembarco de San Martín cuando arribó a Paracas el 8 
                            de setiembre de 1820.<br>  
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-left font-20 text-gris">
                            <br><br>
                            MENCIÓN APARTE MERECE EL "MONUMENTO 
                            CONMEMORATIVO DEL DESEMBARCO DE SAN MARTÍN Y 
                            LA EXPEDICIÓN LIBERTADORA DE PARACAS", UN 
                            OBELISCO DE 18 METROS DE ALTURA SOBRE UNA 
                            PLATAFORMA DE 24 METROS CUADRADOS QUE 
                            CONSTITUYE EL TRABAJO PREMIADO EN EL CONCURSO 
                            "MONUMENTO A PARACAS" PRESENTADO, EN AQUEL 
                            ENTONCES, A LA COMISIÓN. EN EL BOLETÍN MENSUAL 
                            DEL COLEGIO DE ARQUITECTOS SE PRESENTA UNA NOTA 
                            SOBRE EL CONCURSO Y LA MAQUETA GANADORA. 
                            DICHO EJEMPLAR SE ENCUENTRA EN LA SALA DE 
                            HEMEROTECA DE LA BIBLIOTECA NACIONAL DEL PERÚ.<br>  
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoNegro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1">
                            <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-N-003.png">
                    </div>
                    <div class="col-sm-11">
                            <p style="line-height: 120%;margin-bottom: 0%; margin-top: 0%;"
                                class="fontMS700 text-left colorPrincipal font-38">
                                CONCURSO DE MARCHAS MILITARES EN HONOR A LA INDEPENDENCIA<br>
                            </p>
                    </div>
                </div>

                <div class="row marg">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-20 text-white">
                            <br> <br> 
                            OTRA DE LAS ACTIVIDADES RELEVANTES FUE EL CONCURSO DE COMPOSICIÓN DE MARCHAS MILITARES, 
                            DONDE MÚSICOS Y CIUDADANOS EN GENERAL PARTICIPARON EN LA ELABORACIÓN DE LAS PARTITURAS 
                            EN HONOR A LOS FESTEJOS DEL SESQUICENTENARIO. TENIENDO COMO GANADORES:<br><br>
                        </p>
                    </div>
                    <div class="row marg">
                        <div class="col-sm-6">
                            <div class="row">
                                <div class="col-sm-2">
                                    <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-035.png">
                                </div>
                                <div class="col-sm-10">
                                    <p class="fontMS700Italic text-left text-white font-20">
                                        Primer puesto:<br>
                                        “Marcha del Sesquicentenario”<br>
                                        <span class="fontMS300Italic">Jaime Díaz Orihuela<br></span>
                                    </p>
                                </div>
                            </div>

                            <img  width="80%" src="\assets\images\micrositio\micrositio36\SESQUI-036.png">
                            <p class="fontMS300Italic text-center text-white font-12">
                                Fotografía de Jaime Díaz Orihuela.<br> 
                                Fuente: Diario el Búho<br>  
                            </p>
                        </div>
                        <div class="col-sm-6">
                                <a href="http://hdl.handle.net/20.500.14428/79826">
                                    <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-037.png">
                                </a>
                            <p class="fontMS300Italic text-center text-white font-12">
                                <br>
                                Marcha del Sesquicentenario para piano (Versión facilitada). Jaime Díaz Orihuela 
                                (Primer Premio del Consurso para Marcha Militar).
                                Disponible en:<br> 
                                <a href="http://hdl.handle.net/20.500.14428/79826" target="_blank" style="color: #ffffff;">Biblioteca Digital</a><br>  
                            </p>
                        </div>
                    </div>
                    
                    <div class="row marg">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <div class="row">
                                <div class="col-sm-2">
                                    <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-038.png">
                                </div>
                                <div class="col-sm-10">
                                    <p class="fontMS700Italic text-left text-white font-20">
                                        Segundo puesto:<br>
                                        “Marcha Túpac Amaru”<br>
                                        <span class="fontMS300Italic">Ferdinando Andolfo Sannincandro<br></span><br><br>
                                    </p>
                                </div>
                            </div>

                            <a href="http://hdl.handle.net/20.500.14428/79824" target="_blank">
                                <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-039.png">
                            </a>
                            <p class="fontMS300Italic text-center text-white font-12">
                                <br> 
                                Túpac Amaru, Marcha Militar. Por Ferdinando Andolfo Sannicandro.<br>  
                                Disponible en:<br>  
                                <a href="http://hdl.handle.net/20.500.14428/79824" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                                <br>  
                            </p>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                    
                    <div class="row">
                        <div class="col-sm-12">
                                <p class="fontMS100 text-justify text-white font-20">
                                    ESTAS PARTITURAS SE ENCUENTRAN EN LA SALA DE MANUSCRITOS DE LA BNP Y SON ACCESIBLES PARA 
                                    INVESTIGADORES. POSTERIORMENTE, ESTARÁN DIGITALIZADAS EN FORMATO DIGITAL PARA QUE LOS 
                                    USUARIOS DE LA PLATAFORMA PUEDAN REVISARLAS.
                                    <br>  
                                </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1">
                            <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-N-004.png">
                    </div>
                    <div class="col-sm-11">
                            <p style="line-height: 120%;margin-bottom: 0%; margin-top: 1%;"
                                class="fontMS700 text-left colorPrincipal font-38">
                                ESTAMPILLAS CONMEMORATIVAS<br>
                                    
                            </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-24">
                            <br>
                            ENTRE 1970 Y 1971, LA COMISIÓN GESTIONÓ, A TRAVÉS DEL MINISTERIO DE TRANSPORTES Y 
                            COMUNICACIONES, LA EMISIÓN DE ESTAMPILLAS CONMEMORATIVAS POR LOS 150 AÑOS DE VIDA 
                            REPUBLICANA. LA DIRECCIÓN DE CORREO Y TELECOMUNICACIONES FUE LA ENCARGADA DE LA PUBLICACIÓN 
                            DE LAS VEINTE ESTAMPILLAS, DISTRIBUIDAS EN CUATRO SERIES DE CINCO CADA UNA.
                            <br><br>
                        </p>
                    </div>
                </div>
                
                <div class="row ">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-left font-18 ">
                            <br>
                            <span class="fontMS700Italic colorPrincipal font-20">Primera serie:</span> <br><br>
                            Mateo García Pumacahua, Toribio Rodríguez de Mendoza, José Gabriel Condorcanqui - Túpac Amaru II, Francisco Antonio de Zela y 
                            Juan Pablo Viscardo y Guzmán.
                            <br><br>
                        </p>
                    </div>

                    <div class="col-sm-12">
                            <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-040.png">
                    </div>

                    <div class="col-sm-12">
                        <p class="fontMS100 text-left font-18 ">
                            <br>
                            <span class="fontMS700Italic colorPrincipal font-20">Segunda serie:</span> <br><br>
                            Mateo García Pumacahua, Toribio Rodríguez de Mendoza, José Gabriel Condorcanqui - Túpac Amaru II, Francisco Antonio de Zela y 
                            Juan Pablo Viscardo y Guzmán.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-12">
                        <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-041.png">
                    </div>

                    <div class="col-sm-12">
                        <p class="fontMS100 text-left font-18 ">
                            <br>
                            <span class="fontMS700Italic colorPrincipal font-20">Tercera serie:</span> <br><br>
                            José de San Martín, Francisco Vidal, Martín Jorge Guise, José Faustino Sánchez Carrión y Micaela Bastidas.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-12">
                        <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-042.png">
                    </div>

                    <div class="col-sm-12">
                        <p class="fontMS100 text-left font-18 ">
                            <br>
                            <span class="fontMS700Italic colorPrincipal font-20">Cuarta serie:</span> <br><br>
                            Monumento de la Expedición Libertadora, Paracas; Monumento a Antonio Álvarez de Arenales, Cerro de Pasco; La Nación a los 
                            Precursores y Próceres, Lima; Proclamación de la Independencia del Perú, Lima; y Paso del Batallón Numancia al Ejército Patriota.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-12">
                        <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-043.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoNegro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1">
                            <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-N-005.png">
                    </div>
                    <div class="col-sm-11">
                            <p style="line-height: 120%;margin-bottom: 0%; margin-top: 1%;"
                                class="fontMS700 text-left colorPrincipal font-38">
                                EMISIÓN DE MONEDAS CONMEMORATIVAS<br>
                            </p>
                    </div>
                </div>

                <div class="row marg">
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify font-20 text-white">
                            <br> <br> 
                            OTRA DE LAS ACTIVIDADES RELEVANTES FUE EL CONCURSO DE COMPOSICIÓN DE MARCHAS MILITARES, 
                            DONDE MÚSICOS Y CIUDADANOS EN GENERAL PARTICIPARON EN LA ELABORACIÓN DE LAS PARTITURAS 
                            EN HONOR A LOS FESTEJOS DEL SESQUICENTENARIO. TENIENDO COMO GANADORES:<br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <img width="100%"
                        src="\assets\images\micrositio\micrositio36\SESQUI-044.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1">
                            <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-N-006.png">
                    </div>
                    <div class="col-sm-11">
                            <p style="line-height: 120%;margin-bottom: 0%; margin-top: 1%;"
                                class="fontMS700 text-left colorPrincipal font-38">
                                RESTAURACIÓN Y AMPLIACIÓN DEL MUSEO NACIONAL DE ANTROPOLOGÍA,
                                ARQUEOLOGÍA E HISTORIA (MNAAH)<br>
                            </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-center font-20">
                            <br>
                            “LOS ANHELOS DE INDEPENDENCIA Y LIBERTAD, QUE SE VIVIÓ EN ESTA CASA DESDE LOS ALBORES DE LA 
                            REPÚBLICA Y A LO LARGO DEL TRAJÍN POLÍTICO DE LA NACIÓN, ESTUVIERON SIEMPRE AMPARADOS POR EL 
                            AIRE PURO DE LOS GRANDES IDEALES…”
                            <br><br>
                            <span class="fontMS300Italic">DISCURSO DEL PRESIDENTE DEL COMITÉ EJECUTIVO, JUAN MENDOZA RODRÍGUEZ</span> 
                            <br><br><br>
                        </p>
                    </div>

                    <div class="col-sm-12">
                        <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-045.png">
                    </div>
                </div>
                
                <div class="row ">
                    <div class="col-sm-6">
                        <p class="fontMS100 text-left font-18">

                            <br><br><br>
                            <span class="fontMS700Italic font-20">ENTRE LAS OBRAS REALIZADAS EN EL MUSEO DE HISTORIA DESTACAN:</span> <br><br>
                            <ul>
                                <li>RESTAURACIÓN DE LA SALA DE REPÚBLICA.</li><br>
                                <li>RECONSTRUCCIÓN DE LA FACHADA.</li><br>
                                <li>CONSTRUCCIÓN DE UN DEPÓSITO.</li><br>
                                <li>ARREGLO GENERAL DEL LOCAL Y LA MUEBLERÍA.
                                CONSTRUCCIÓN DE NUEVOS DEPÓSITOS PARA EL MUSEO DE ARQUEOLOGÍA Y ANTROPOLOGÍA.
                                REPARACIÓN DE LA TUMBA DE JULIO C. TELLO.</li>
                            </ul>
                            <br><br>
                        
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <br><br><br><br>
                            <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-046.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoNegro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1">
                            <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-N-007.png">
                    </div>
                    <div class="col-sm-11">
                            <p style="line-height: 120%;margin-bottom: 0%; margin-top: 2%;"
                                class="fontMS700 text-left colorPrincipal font-38">
                                V CONGRESO INTERNACIONAL DE HISTORIA DE AMÉRICA<br>
                            </p>
                    </div>
                </div>

                <div class="row marg">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-20 text-white">
                            <br> <br> 
                            FUE UN ENCUENTRO CIENTÍFICO QUE REUNIÓ A IMPORTANTES INVESTIGADORES DE LA HISTORIA E 
                            HISTORIOGRAFÍA AMERICANA.<br>
                            EL TEMA PRINCIPAL ESTABA RELACIONADO A: <span class="fontMS500">"EL PERÚ Y LOS PRÓCERES EN SU INDEPENDENCIA Y EN 
                                HISPANOAMÉRICA". </span><br><br>
                        </p>
                    </div>
                    
                    <div class="row ">
                        <div class="col-sm-4">
                            <br><br><br>
                                <a href="http://hdl.handle.net/20.500.14428/79857" target="_blank">
                                    <img  width="100%" src="\assets\images\micrositio\micrositio36\SESQUI-047.png">
                                </a>
                                
                        </div>
                        <div class="col-sm-2"></div>
                        <div class="col-sm-6">
                                <p class="fontMS100 text-left font-18 text-white">
                                    <br><br><br>
                                    <span class="fontMS100 font-20">EXISTIERON OTROS TEMAS QUE SIGNIFICARON AMPLIO 
                                        DEBATE Y ANÁLISIS POR LOS HISTORIADORES INVITADOS, 
                                        TALES COMO:</span> <br><br>
                                    <ul class="text-white">
                                        <li>REBELIONES PRECURSORAS DE LA INDEPENDENCIA.</li>
                                        <li>LA IDEOLOGÍA DE LA EMANCIPACIÓN.</li>
                                        <li>ESTADO SOCIAL DEL PERÚ EN LA ÉPOCA DE LA INDEPENDENCIA</li>
                                        <li>CAMPAÑA Y OBRA DE GOBIERNO DE SAN MARTÍN EN EL PERÚ.</li>
                                        <li>CAMPAÑA Y OBRA DE GOBIERNO DE BOLÍVAR EN EL PERÚ.</li>
                                        <li>PERUANOS EN LA INDEPENDENCIA DE HISPANOAMÉRICA.</li>
                                        <li>EL PROCESO DE LA CULTURA LATINOAMERICANA Y LA EMANCIPACIÓN.</li>
                                    </ul>
                                    <br><br>
                                
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1">
                            <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-N-008.png">
                    </div>
                    <div class="col-sm-11">
                            <p style="line-height: 120%;margin-bottom: 0%; margin-top: 1%;"
                                class="fontMS700 text-left colorPrincipal font-38">
                                CURSO DE PERFECCIONAMIENTO PARA PROFESORES DE HISTORIA<br>
                            </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-20">
                            <br>
                            SE REALIZARON TRES CICLOS DE CONFERENCIAS ENTRE 1970 Y 1974, LAS CUALES ESTABAN DIRIGIDAS A 
                            DOCENTES DE HISTORIA DE PRIMARIA, SECUNDARIA Y NORMAL.
                            <br><br>
                            EL PROPÓSITO DEL CURSO FUE EVIDENCIAR LA MAGNITUD DEL ESFUERZO PERUANO DURANTE LOS SIGLOS 
                            XVIII Y XIX, A TRAVÉS DEL LARGO PROCESO INDEPENDENTISTA. DESDE TÚPAC AMARU II, LAS CONSPIRACIONES 
                            Y REBELIONES QUE PROCEDIERON A LA EXPEDICIÓN LIBERTADORA, HASTA EL TIEMPO DE GOBIERNO DE DON 
                            JOSÉ DE SAN MARTÍN.
                            <br><br>
                        </p>
                    </div>
                </div>
                
                <div class="row ">
                    <div class="col-sm-5">
                        <br><br>
                        <a href="http://hdl.handle.net/20.500.14428/79845" target="_blank">
                            <img  width="80%" src="\assets\images\micrositio\micrositio36\SESQUI-048.png">
                        </a>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-6">
                            <p class="fontMS100 text-left font-18">
                                <br><br>
                                LAS PRINCIPALES TAREAS DEL CURSO FUERON AFIRMAR 
                                EL ESFUERZO PRECURSOR, EL DESARROLLO DE UNA 
                                CONCIENCIA CÍVICA Y LA DIFUSIÓN DE FUENTES 
                                DOCUMENTALES PARA QUE PUEDA SER UTILIZADO POR 
                                EL PROFESORADO. DESTACA LA PARTICIPACIÓN DE 
                                ALGUNOS MIEMBROS DE LA COMISIÓN E 
                                INVESTIGADORES IMPORTANTES DE LA ÉPOCA:<br><br>
                                JOSÉ DE LA PUENTE CANDAMO<br>
                                GUILLERMO DURAND<br>
                                CARLOS DANIEL VALCÁRCEL<br>
                                CESAR PACHECO<br>
                                JULIO VÉLEZ<br>
                                GUSTAVO PONS MUZZO<br>
                                JUAN MENDOZA
                                
                            </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%; margin-top: 1%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio36\SESQUI-LINEA-000.png">
                </div>

                <div class="row marg">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify  font-24">
                            <br>
                            Recomendamos algunas de las fuentes consultadas durante la investigación.
                            
                        </p>
                    </div>
                </div>

                <div class="row marg">
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify  font-24">
                            
                            <span class="fontMS500">Aguirre, Carlos (2018)</span>  ¿La segunda liberación? El 
                            nacionalismo militar y la conmemoración del 
                            sesquicentenario de la independencia peruana. En: 
                            Carlos Aguirre y Paulo Drinot (eds). La Revolución 
                            Peculiar: Repensando el Gobierno Militar de Velasco 
                            (pp. 41-70). Lima: IEP
                            <br>
                        </p>
                        <p class="fontMS100 text-justify  font-24">
                            <br>
                            <span class="fontMS500">Temple, E. (1975). Comisión Nacional del 
                                Sesquicentenario de la Independencia del Perú. </span>  
                                Revista de Historia de América, (79), 148-154.
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify  font-24">
                            
                            <span class="fontMS500">Boletin Informativo de la Comisión Nacional del 
                            Sesquicentenario de la Independencia del Perú 
                            (1970-1973).</span> Números 1-19.
                            <br>
                        </p>
                        <p class="fontMS100 text-justify  font-24">
                            <br>
                            <span class="fontMS500">Banco Central de Reserva (2020). Sesquicentenario 
                                de la Batalla de Ayacucho. Recuperado de:</span> 
                                <a href="https://tiendavirtual.bcrp.gob.pe/tiendabcrp/monedas-conmemorativas/43-sesquicentenario-de-la-batalla-de-ayacucho.html" target="_blank" style="color: black;">
                                    https://tiendavirtual.bcrp.gob.pe/tiendabcrp/<br>
                                    monedas-conmemorativas/43-sesquicentenario-<br>
                                    de-la-batalla-de-ayacucho.html</a>
                                
                            <br>
                        </p>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>

